export interface AdanaDistrict {
  name: string;
  slug: string;
  description: string;
  focus: string;
  checks: string[];
}

export const ADANA_DISTRICT_SOURCE = {
  title: "Adana Büyükşehir Belediyesi — İlçe adları",
  url: "https://www.adana.bel.tr/panel/uploads/mecliskararlari_v/files/2024-aralik-ayi-pdf.pdf",
};

export const ADANA_OFFICIAL_SOURCES = [
  ADANA_DISTRICT_SOURCE,
  { title: "Adana İl Kültür ve Turizm Müdürlüğü — İlçeleri", url: "https://adana.ktb.gov.tr/TR-60705/ilceleri.html" },
  { title: "Tapu ve Kadastro Genel Müdürlüğü — Parsel Sorgu", url: "https://parselsorgu.tkgm.gov.tr/" },
  { title: "Tapu ve Kadastro Genel Müdürlüğü — Web Tapu", url: "https://webtapu.tkgm.gov.tr/" },
  { title: "Adana Büyükşehir Belediyesi", url: "https://www.adana.bel.tr/" },
];

// Names checked against the municipality's December 2024 council record.
// Viewing prompts are editorial advice, not market forecasts or legal conclusions.
export const ADANA_DISTRICTS: AdanaDistrict[] = [
  {
    name: "Seyhan", slug: "seyhan",
    description: "Seyhan’da konut ve işyeri arayışını mahalle, bina özellikleri ve günlük ulaşım ihtiyacına göre daraltın.",
    focus: "Şehir içi yaşam ve ticari kullanım",
    checks: ["İşe ve okula ulaşım rotasını farklı saatlerde deneyin.", "Apartman aidatını, ortak alanları ve bakım kayıtlarını isteyin.", "İşyeri için kullanım amacını ve cephe koşullarını yerinde inceleyin."],
  },
  {
    name: "Çukurova", slug: "cukurova",
    description: "Çukurova’da daire veya villa seçerken cephe, açık alan, aidat ve net kullanım alanını birlikte karşılaştırın.",
    focus: "Konut, villa ve site yaşamı",
    checks: ["Manzara ve güneş alma durumunu doğrudan mülkten kontrol edin.", "Site hizmetlerinin kapsamını ve güncel aidatını öğrenin.", "Villa için bahçe sınırını ve bakım maliyetlerini inceleyin."],
  },
  {
    name: "Sarıçam", slug: "saricam",
    description: "Sarıçam’da konut ve arsa seçeneklerini değerlendirirken mevcut altyapı ile planlarda belirtilen kullanımı ayırın.",
    focus: "Konut ve parsel değerlendirmesi",
    checks: ["Elektrik, su ve yol bağlantısının mevcut durumunu yerinde görün.", "Arsa için güncel imar bilgisini ilgili belediyeden isteyin.", "Ulaşım ihtiyacınızı ilan adresi üzerinden değerlendirin."],
  },
  {
    name: "Yüreğir", slug: "yuregir",
    description: "Yüreğir’de satılık veya kiralık mülkleri mahalle konumu, bina durumu ve kullanım ihtiyacınıza göre inceleyin.",
    focus: "Mahalle yaşamı ve ulaşım",
    checks: ["Mahalledeki günlük ihtiyaç noktalarına gerçek mesafeleri ölçün.", "İlanda yazan kat ve oda bilgisini mülkün planıyla karşılaştırın.", "Bina ve ortak alanların mevcut bakım durumunu kontrol edin."],
  },
  {
    name: "Ceyhan", slug: "ceyhan",
    description: "Ceyhan’da merkezdeki konutları, ticari mülkleri ve arazi seçeneklerini ayrı kullanım hedefleriyle karşılaştırın.",
    focus: "Konut, ticaret ve arazi",
    checks: ["Konutun iş yerinize ulaşımını adres üzerinden planlayın.", "Ticari mülk için erişim, giriş ve yükleme koşullarını inceleyin.", "Arazi için tapudaki nitelik ile sahadaki kullanımı karşılaştırın."],
  },
  {
    name: "Kozan", slug: "kozan",
    description: "Kozan’da ilçe merkezindeki konutlarla çevre yerleşimlerdeki mülkleri ulaşım ve bakım gereksinimi açısından değerlendirin.",
    focus: "İlçe merkezi ve çevre yerleşimler",
    checks: ["Merkez ile mülk arasındaki ulaşımı bizzat deneyin.", "Müstakil yapıda çatı, yalıtım ve bakım ihtiyacını inceleyin.", "Arazi sınırlarını ada ve parsel bilgisiyle eşleştirin."],
  },
  {
    name: "İmamoğlu", slug: "imamoglu",
    description: "İmamoğlu’nda daire, işyeri veya arazi ararken ana ulaşım bağlantısını ve mülkün mevcut kullanımını birlikte inceleyin.",
    focus: "İlçe yaşamı ve yol bağlantıları",
    checks: ["Ana yola mesafeyi ve mülke giriş koşullarını yerinde görün.", "İşyeri için görünürlük ve park alanını değerlendirin.", "Arazide altyapı bağlantılarının durumunu ilgili kurumdan öğrenin."],
  },
  {
    name: "Karataş", slug: "karatas",
    description: "Karataş’ta kıyı yaşamını düşünürken mülkün kullanım dönemi, bakım ihtiyacı ve parsel konumu üzerinde durun.",
    focus: "Kıyı yaşamı ve dönemsel kullanım",
    checks: ["Denize yakınlık ifadesini harita ve yerinde ziyaretle doğrulayın.", "Yapının nem, yalıtım ve dönemsel bakım ihtiyacını inceleyin.", "Kıyıya yakın parselin plan bilgilerini ilgili idareden isteyin."],
  },
  {
    name: "Yumurtalık", slug: "yumurtalik",
    description: "Yumurtalık’ta konut veya arazi arayışında kıyı konumunu, erişimi ve mevcut çevre kullanımını birlikte değerlendirin.",
    focus: "Kıyı konumu ve çevre kullanımı",
    checks: ["Mülkün yakın çevresini hafta içi ve hafta sonu ziyaret edin.", "Yıl boyunca su, elektrik ve ulaşım koşullarını öğrenin.", "Arazide ilan edilen kullanım için güncel plan bilgisini isteyin."],
  },
  {
    name: "Karaisalı", slug: "karaisali",
    description: "Karaisalı’da merkez, kırsal ve yayla seçeneklerini yıl boyu erişim, altyapı ve bakım ihtiyaçlarına göre karşılaştırın.",
    focus: "Kırsal mülk ve yayla kullanımı",
    checks: ["Yolun mevsimlere göre erişilebilirliğini yerel kaynaklardan öğrenin.", "Yapı ile arazinin sınırlarını tapu bilgisiyle karşılaştırın.", "Isıtma, su ve atık su sistemlerinin durumunu inceleyin."],
  },
  {
    name: "Pozantı", slug: "pozanti",
    description: "Pozantı’da sürekli veya dönemsel yaşam hedefinize göre konutun ısıtma, yalıtım ve ulaşım koşullarını değerlendirin.",
    focus: "Yıl boyu yaşam ve dönemsel konut",
    checks: ["Kış dönemi ısıtma maliyetleri ve yalıtım durumunu öğrenin.", "Mülke ulaşımı yalnızca yaz koşullarına göre değerlendirmeyin.", "Boş kaldığı dönemde bakım ve güvenlik ihtiyacını planlayın."],
  },
  {
    name: "Aladağ", slug: "aladag",
    description: "Aladağ’da yayla veya kırsal mülk seçerken arazinin yapısını, erişimi ve temel altyapı koşullarını yerinde inceleyin.",
    focus: "Yayla ve kırsal yaşam",
    checks: ["Arazi eğimini ve yapıya ulaşım yolunu yerinde görün.", "Su ve elektrik bağlantıları hakkında güncel bilgi alın.", "Yapıların mevcut durumunu ve bakım ihtiyacını uzmanla değerlendirin."],
  },
  {
    name: "Feke", slug: "feke",
    description: "Feke’de ilçe merkezi veya çevre yerleşimlerdeki mülkleri ulaşım, arazi yapısı ve kullanım hedefinizle birlikte inceleyin.",
    focus: "Arazi yapısı ve yerleşim seçimi",
    checks: ["Mülke erişim yolunun mevcut durumunu ziyaret sırasında kontrol edin.", "Arazinin sınırı ile ilanda kullanılan fotoğrafları eşleştirin.", "Konutun onarım ve ısıtma gereksinimlerini bütçenize ekleyin."],
  },
  {
    name: "Saimbeyli", slug: "saimbeyli",
    description: "Saimbeyli’de mülk ararken merkeze erişim, günlük ihtiyaçlar ve farklı mevsimlerde kullanım koşullarını birlikte düşünün.",
    focus: "Mevsimsel kullanım ve günlük ihtiyaçlar",
    checks: ["Sağlık, alışveriş ve ulaşım ihtiyaçlarınız için gerçek rotaları belirleyin.", "Yapının kış kullanımına uygunluğunu yerinde inceleyin.", "Arazi seçeneklerinde mülke erişim ve sınır bilgisini doğrulayın."],
  },
  {
    name: "Tufanbeyli", slug: "tufanbeyli",
    description: "Tufanbeyli’de konut veya arazi seçiminizi yıl boyu erişim, ısıtma ihtiyacı ve tapudaki mülk niteliğine göre yapın.",
    focus: "Yıl boyu erişim ve kullanım maliyeti",
    checks: ["Kışın ulaşım ve ısınma için gereken koşulları öğrenin.", "Yapının çatı ve yalıtım durumunu inceleyin.", "Arazi için ada, parsel ve tapudaki niteliği karşılaştırın."],
  },
];

export const ADANA_BUYER_QUESTIONS = [
  {
    question: "Adana’da satılık ve kiralık ilanları nasıl karşılaştırabilirim?",
    answer: "Önce ilçe, mahalle, bütçe ve mülk tipini belirleyin. Ardından net alan, bina özellikleri, aidat, kullanım durumu ve ulaşım ihtiyacını aynı ölçütlerle karşılaştırın. İlan fiyatları mülk bazındaki talep fiyatlarıdır; tek başına bölge ortalaması veya gerçekleşmiş satış fiyatı anlamına gelmez.",
  },
  {
    question: "Adana’da arsa ararken nereden başlamalıyım?",
    answer: "İlandaki ada ve parseli TKGM Parsel Sorgu üzerinden haritadaki konumla eşleştirin. Güncel imar durumu, yol ve altyapı bilgilerini ilgili belediye ve kurumlarla doğrulayın. Haritada görünen konum veya ilandaki ‘imarlı’ ifadesi tek başına yapılaşma koşullarını açıklamaz.",
    source: "https://parselsorgu.tkgm.gov.tr/", sourceTitle: "TKGM Parsel Sorgu",
  },
  {
    question: "İlan olmayan bir ilçede danışmanlık talep edebilir miyim?",
    answer: "Evet. İlgilendiğiniz ilçeyi, mülk tipini ve ihtiyaçlarınızı WhatsApp üzerinden paylaşabilirsiniz. Bir ilçenin rehberde yer alması, o ilçede her zaman aktif ilan veya ayrı bir ofis bulunduğu anlamına gelmez.",
  },
  {
    question: "Bu rehberdeki bilgiler nasıl hazırlanıyor?",
    answer: "İlçe adları resmî belediye kaydından, genel ilçe tanıtımları resmî kültür ve turizm kaynağından kontrol edilmiştir. Kontrol listeleri, mülk ziyaretini planlamanız için hazırlanmış editoryal önerilerdir. Güncel fiyat ve özellikler için ilgili ilanı ve mülkün belgelerini inceleyin.",
    source: ADANA_DISTRICT_SOURCE.url, sourceTitle: ADANA_DISTRICT_SOURCE.title,
  },
];
